import api from "../../services/api";

const path = "v1/servico";

export const getServices = async (params = "") => {
  return await api.get(`${path}${params}`);
};

export const postService = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const putService = async ({ body, id }) => {
  return await api.put(`${path}/${id}`, body);
};

export const getCustomersServices = async () => {
  return await api.get(`${path}/cliente`);
};

export const postCustomersServices = async ({ body }) => {
  return await api.post(`${path}/cliente`, body);
};
